import script from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDropdown.vue?vue&type=style&index=0&id=f630f126&scoped=true&lang=css"

import exportComponent from "/srv/apps/jenkins/workspace/Hybris/PACK-zip-archives-for-deployment-v3/bin/custom/ocm/ocmstorefront/web/webroot/WEB-INF/_ui-src/packages/contact/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f630f126"]])

export default __exports__